import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d94aa6c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-truncate" }
const _hoisted_2 = { class: "text-truncate" }
const _hoisted_3 = { class: "text-truncate" }
const _hoisted_4 = { class: "text-truncate" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-v fs-5" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_VZSideDrawer = _resolveComponent("VZSideDrawer")!
  const _component_VZDeleteModal = _resolveComponent("VZDeleteModal")!
  const _component_vz_lookup_clone_modal = _resolveComponent("vz-lookup-clone-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Datatable, {
      "table-data": _ctx.tableData,
      "table-header": _ctx.tableHeader,
      total: _ctx.total,
      rowsPerPage: _ctx.rowsPerPage,
      page: _ctx.page,
      loading: _ctx.loading,
      showSearch: _ctx.showSearch,
      defaultFilter: _ctx.defaultFilter,
      tableFilter: _ctx.tableFilter,
      bulkDelete: _ctx.bulkDelete,
      tableForm: _ctx.formData,
      addButtonText: `${_ctx.t('pages.lookup.addLookup')}`,
      viewName: "lookup",
      onQueryUpdate: _ctx.queryUpdate,
      onTableRowClick: _ctx.tableRowClick,
      onFormSubmit: _ctx.submit,
      permissions: _ctx.permissionModel,
      ref: "datatable"
    }, {
      "cell-lookupName": _withCtx(({ row: lookup }) => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(lookup.lookupName), 1)
      ]),
      "cell-startDate": _withCtx(({ row: lookup }) => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.format.convertUTCToLocalDate(lookup.startDate)), 1)
      ]),
      "cell-endDate": _withCtx(({ row: lookup }) => [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.format.convertUTCToLocalDate(lookup.endDate)), 1)
      ]),
      "cell-createdBy": _withCtx(({ row: lookup }) => [
        _createElementVNode("span", _hoisted_4, _toDisplayString(lookup.createdBy), 1)
      ]),
      "cell-status": _withCtx(({ row: lookup }) => [
        _createElementVNode("span", {
          class: _normalizeClass(["text-truncate fw-bolder", {
          'badge badge-success': lookup.status?.toLowerCase() === 'active',
          'badge badge-danger': lookup.status?.toLowerCase() !== 'active',
        }])
        }, _toDisplayString(_ctx.format.TitleCase(lookup.status?.toLowerCase())), 3)
      ]),
      "cell-actions": _withCtx(({ row: lookup }) => [
        (!lookup.lock && _ctx.hasPermission(_ctx.permissionModel.update))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _withModifiers(($event: any) => (_ctx.editLookup(lookup)), ["stop"]),
              "data-bs-toggle": "modal",
              "data-bs-target": "#vz-add-edit-modal-lookup",
              class: "btn btn-icon btn-primary btn-circle btn-sm"
            }, _hoisted_7, 8, _hoisted_5))
          : _createCommentVNode("", true),
        (!lookup.lock && _ctx.hasPermission(_ctx.permissionModel.delete))
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              onClick: _withModifiers(
          () => {
            _ctx.showDeleteDialog = true;
            _ctx.selectedForAction = lookup;
          }
        , ["stop"]),
              class: "btn btn-icon btn-danger btn-circle btn-sm ms-3"
            }, _hoisted_10, 8, _hoisted_8))
          : _createCommentVNode("", true),
        (lookup.lock)
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
              class: "btn btn-icon btn-secondary btn-circle btn-sm ms-1"
            }, _hoisted_12))
          : _createCommentVNode("", true)
      ]),
      "cell-clone": _withCtx(({ row: lookup }) => [
        _createElementVNode("button", {
          onClick: _withModifiers(($event: any) => (_ctx.resetWebId(lookup.webId)), ["stop"]),
          type: "button",
          "data-bs-toggle": "dropdown",
          class: "btn btn-outline btn-outline-primary btn-active-light-primary btn-icon btn-circle btn-sm ms-3",
          "aria-expanded": "false"
        }, _hoisted_15, 8, _hoisted_13),
        _createElementVNode("ul", {
          class: _normalizeClass(["dropdown-menu dropdown-menu-end border lookup-clone", 'show-clone-' + lookup.webId])
        }, [
          _createElementVNode("li", null, [
            (_ctx.hasPermission(_ctx.permissionModel.create))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _withModifiers(($event: any) => (_ctx.setLookupCloneData(lookup)), ["stop"]),
                  class: "dropdown-item py-2 text-hover-primary",
                  type: "button"
                }, _toDisplayString(_ctx.t("pages.user.clone.title")), 9, _hoisted_16))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ]),
      _: 1
    }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "defaultFilter", "tableFilter", "bulkDelete", "tableForm", "addButtonText", "onQueryUpdate", "onTableRowClick", "onFormSubmit", "permissions"]),
    _createVNode(_component_VZSideDrawer, {
      modelValue: _ctx.openDrawer,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.openDrawer) = $event)),
      title: _ctx.sideDrawerTitle,
      icon: _ctx.sideDrawerIcon,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openDrawer = false)),
      tabs: _ctx.tabs
    }, null, 8, ["modelValue", "title", "icon", "tabs"]),
    (_ctx.hasPermission(_ctx.permissionModel.delete))
      ? (_openBlock(), _createBlock(_component_VZDeleteModal, {
          key: 0,
          showDialog: _ctx.showDeleteDialog,
          viewName: "lookups",
          selectedForAction: [_ctx.selectedForAction.webId],
          pageName: "lookup",
          deleteText: `${_ctx.t('validation.sureToDelete')} ${
      _ctx.selectedForAction.lookupName
    }?`,
          onClose: _ctx.refreshList
        }, null, 8, ["showDialog", "selectedForAction", "deleteText", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.openCloneModal)
      ? (_openBlock(), _createBlock(_component_vz_lookup_clone_modal, {
          key: 1,
          lookup: _ctx.lookupObj,
          onCloneSubmit: _ctx.refreshList,
          onOnCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openCloneModal = false))
        }, null, 8, ["lookup", "onCloneSubmit"]))
      : _createCommentVNode("", true)
  ], 64))
}